/*ハンバーガーメニュー*/
document.addEventListener('DOMContentLoaded', () => {
  const hamburger = document.querySelector('.rub_header_hamburger');
  const navi = document.querySelector('.rub_header_navi');
  const sectionHeader = document.querySelector('.section-header');
  const announcementBar = document.querySelector('.announcement-bar-section');
  const body = document.body;
  const html = document.documentElement;
  let scrollPosition = 0;

  if (hamburger && navi) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('is-open');
      navi.classList.toggle('is-open');

      if (navi.classList.contains('is-open')) {
        scrollPosition = window.pageYOffset;

        let totalHeaderHeight = 0;
        if (scrollPosition === 0) {
          const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
          const headerHeight = sectionHeader ? sectionHeader.offsetHeight : 0;
          totalHeaderHeight = announcementBarHeight + headerHeight;
        }

        if (scrollPosition === 0) {
          navi.style.paddingTop = `${totalHeaderHeight}px`;
        } else {
          navi.style.paddingTop = '60px';
        }

        const announcementBarHeight =
          scrollPosition === 0 && announcementBar ? announcementBar.offsetHeight : 0;

        if (sectionHeader) {
          sectionHeader.style.position = 'fixed';
          sectionHeader.style.top = `${announcementBarHeight}px`;
          sectionHeader.style.width = '100%';
          sectionHeader.style.transform = 'none';
        }

        html.style.overflow = 'hidden';
        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = `-${scrollPosition}px`;
        body.style.width = '100%';
      } else {
        if (sectionHeader) {
          sectionHeader.style.position = '';
          sectionHeader.style.top = '';
          sectionHeader.style.width = '';
          sectionHeader.style.transform = '';
        }

        navi.style.paddingTop = '';

        html.style.overflow = '';
        body.style.overflow = '';
        body.style.position = '';
        body.style.top = '';
        body.style.width = '';

        window.scrollTo(0, scrollPosition);
      }
    });
  }
});

/*ヘッダー動作*/
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.section-header');
  if (!header) return;

  let lastScrollTop = 0;

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop && scrollTop > 100) {
      header.classList.add('is-hidden');
      header.classList.remove('is-visible');
    } else {
      header.classList.remove('is-hidden');
      header.classList.add('is-visible');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
});

/*スムーススクロール*/
document.addEventListener('DOMContentLoaded', () => {
  // accountページでは何もしない
  if (location.pathname.includes('/account')) return;

  const headerHeight = 30;

  document.querySelectorAll("a[href^='#']").forEach(anchor => {
    anchor.addEventListener('click', e => {
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;

      const target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();
      history.pushState(null, null, href);

      const position = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    });
  });
});

/*ページトップへ戻るボタン*/
document.addEventListener('DOMContentLoaded', () => {
  const pageTopBtn = document.getElementById('page_top');
  if (!pageTopBtn) return;

  window.addEventListener('scroll', () => {
    if (window.pageYOffset > 300) {
      pageTopBtn.classList.add('show');
    } else {
      pageTopBtn.classList.remove('show');
    }
  });

  pageTopBtn.addEventListener('click', e => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});

/*アコーディオンメニュー*/
document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.js-accordion');

  function initAccordion() {
    if (window.matchMedia('(max-width: 750px)').matches) {
      accordions.forEach(el => {
        const target = el.nextElementSibling;
        if (!el.classList.contains('is-open') && target) {
          target.style.maxHeight = '0px';
        }
      });
    } else {
      document
        .querySelectorAll('.rub_header .js-accordion')
        .forEach(el => {
          el.classList.remove('is-open');
          const target = el.nextElementSibling;
          if (target) target.style.maxHeight = '0px';
        });
    }
  }

  initAccordion();

  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 751px)').matches) {
      accordions.forEach(el => {
        if (!el.closest('.rub_header')) {
          const target = el.nextElementSibling;
          if (target) {
            target.style.maxHeight = '';
          }
        }
      });

      document
        .querySelectorAll('.rub_header .js-accordion')
        .forEach(el => {
          el.classList.remove('is-open');
          const target = el.nextElementSibling;
          if (target) target.style.maxHeight = '0px';
        });
    } else {
      initAccordion();
    }
  });

  accordions.forEach(el => {
    el.addEventListener('click', () => {
        const target = el.nextElementSibling;
        if (!target) return;

        if (el.classList.contains('is-open')) {
          // 閉じる処理（今の高さを一度固定してから0へ）
          //target.style.maxHeight = target.scrollHeight + 'px';
          target.style.maxHeight = '1000px';
          requestAnimationFrame(() => {
            target.style.maxHeight = '0px';
          });
          el.classList.remove('is-open');
        } else {
          // 開く処理
          el.classList.add('is-open');
          //target.style.maxHeight = target.scrollHeight + 'px';
          target.style.maxHeight = '1000px';
        }
    });
  });
});